export default __webpack_public_path__ + "static/media/slot1.5c255020.png";